import { render, staticRenderFns } from "./Alert.vue?vue&type=template&id=3be5eb3d&scoped=true&"
import script from "./Alert.vue?vue&type=script&lang=ts&"
export * from "./Alert.vue?vue&type=script&lang=ts&"
import style0 from "./Alert.vue?vue&type=style&index=0&id=3be5eb3d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be5eb3d",
  null
  
)

export default component.exports